import { render, staticRenderFns } from "./PaymentDetailTab.vue?vue&type=template&id=5fc9d8b0&scoped=true"
import script from "./PaymentDetailTab.vue?vue&type=script&lang=js"
export * from "./PaymentDetailTab.vue?vue&type=script&lang=js"
import style0 from "./PaymentDetailTab.vue?vue&type=style&index=0&id=5fc9d8b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc9d8b0",
  null
  
)

export default component.exports